module.exports = __webpack_public_path__ + "static/media/thumbnail.680264c1.jpg";